const profile = {
  name: "Anoop DM",
  handle: "anoopdm",
  initials: "ADM",
  role: "Backend Engineer | Technical Architect",
  location: "Bengaluru",
  email: "anoopdm11@gmail.com",
  website: "https://www.anoopdm.com",
  seo: {
    title: "Anoop DM (anoopdm) | Backend Engineer | Technical Architect",
    description:
      "Anoop DM, known online as anoopdm, is a backend-focused engineer specializing in scalable systems, APIs, cloud architecture, PHP, Node.js, and modern DevOps practices.",
  },
  titles: [
    "Backend Specialist",
    "System Design Enthusiast",
    "Full Stack Developer",
  ],
  social: {
    github: "https://github.com/anoop-manjunath",
    linkedin: "https://www.linkedin.com/in/anoop-d-m-8b616a86/",
    leetcode: "https://leetcode.com/u/uYeaSdi8GR/",
    instagram: "https://www.instagram.com/anoop_dm",
    medium: "https://medium.com/@anoopmanjunath_32129",
  },
  home: {
    intro:
      "I design and build scalable backend systems that power high-performance applications.",
    summary:
      "From API design to cloud deployment, I focus on reliable backend architecture, resilient services, and shipping production-ready systems with clarity.",
    focus: [
      {
        label: "Primary Focus",
        value: "Scalable backend systems, APIs, and architecture",
      },
      {
        label: "Core Stack",
        value: "PHP, Node.js, Laravel, Symfony, AWS",
      },
      {
        label: "Supporting Frontend",
        value: "Vue.js and React for production-ready delivery",
      },
      {
        label: "Open To",
        value: "Backend engineering, architecture, and backend-focused full stack roles",
      },
    ],
  },
  about: {
    paragraphs: [
      "Backend-focused engineer with strong expertise in building scalable, secure, and high-performance web applications. Experienced in system design, API development, and cloud-based architectures.",
      "I specialize in backend engineering using PHP and Node.js, with solid experience in databases, distributed systems, and DevOps practices. I also work with Vue.js and React when needed to deliver complete, production-ready solutions.",
      "Certified Scrum Master (PSM I) with experience facilitating agile teams and improving delivery efficiency.",
    ],
    education: {
      degree: "Master of Computer Application (M.C.A)",
      institution: "Acharya Institute Of Technology, VTU",
      year: "2017",
    },
    openTo: [
      "Backend Engineering Roles",
      "System Design & Architecture",
      "Full Stack (Backend-Focused)",
    ],
    specializations: [
      { label: "Backend", value: "PHP, Node.js" },
      { label: "Frameworks", value: "Laravel, Symfony" },
      { label: "Databases", value: "MySQL, MongoDB, DynamoDB" },
      { label: "Cloud & DevOps", value: "AWS, Serverless, Docker, CI/CD" },
      { label: "Messaging", value: "Kafka, RabbitMQ, AWS SQS" },
      { label: "Practices", value: "System Design, REST APIs, TDD" },
    ],
  },
  experience: [
    {
      company: "DevOn Software Services Pvt. Ltd.",
      title: "Technical Architect | Scrum Master",
      period: "2024 - Present",
    },
    {
      company: "Simplilearn Solutions Pvt Ltd",
      title: "SDE 4",
      period: "2021 - 2024",
    },
    {
      company: "Infiniti Research Pvt Ltd",
      title: "Software Engineer",
      period: "2018 - 2021",
    },
    {
      company: "Independent Consultant",
      title: "Full Stack Web Developer",
      period: "2017 - 2018",
    },
  ],
  certifications: [
    {
      name: "Professional Scrum Master I (PSM I)",
      issuer: "Scrum.org",
      year: "2024",
    },
    {
      name: "DevOps Foundation",
      issuer: "DevOps Institute, PeopleCert",
      year: "2025",
    },
  ],
  skills: [
    "PHP",
    "Node.js",
    "Laravel",
    "Symfony",
    "MySQL",
    "MongoDB",
    "DynamoDB",
    "AWS",
    "Docker",
    "Kafka",
    "RabbitMQ",
    "Vue.js",
    "React",
    "REST APIs",
    "System Design",
    "TDD",
  ],
};

export default profile;
